import { render, staticRenderFns } from "./StudyList.vue?vue&type=template&id=5d4b98a0"
import script from "./StudyList.vue?vue&type=script&lang=js"
export * from "./StudyList.vue?vue&type=script&lang=js"
import style0 from "./StudyList.vue?vue&type=style&index=0&id=5d4b98a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports